import { IconBuses, IconRideInterconnection, IconTimetable } from '@flixbus/honeycomb-icons-react';

import { CREATE_BREAKDOWN_FLOW_TEXT } from 'pages/WorkAssignments/components/CreateBreakdownFlow/texts';
import { formatSummaryDateTime } from 'utils/datetime/fnsTimeFormatter';

const LABELS = CREATE_BREAKDOWN_FLOW_TEXT.summary.rowLabels;

const formatStation = (station) => {
	if (!station?.code) return '';
	if (!station.name) return station.code;
	return `${station.code} (${station.name})`;
};

/**
 * Build the "Parallel ride" rows from an accepted breakdown. Mirrors the
 * flow-side deriver — `breakdown.parallelRide` shape is identical to the
 * flow draft's `data.parallelRide`.
 *
 * @param {object} breakdown
 * @returns {import('common/BreakdownDetails').BreakdownDetailsRow[]}
 */
export const deriveParallelRideRowsFromBreakdown = (breakdown) => {
	const ride = breakdown?.parallelRide;
	if (!ride) return [];

	const stations = ride.stations ?? [];
	const first = stations[0];
	const last = stations[stations.length - 1];

	return [
		{
			label: LABELS.tripLine,
			value: `TN ${ride.tripNumber ?? ''} / ${ride.lineCode ?? ''}`,
			icon: IconBuses,
		},
		{
			label: LABELS.route,
			value: `${formatStation(first)} → ${formatStation(last)}`,
			icon: IconRideInterconnection,
		},
		{
			label: LABELS.departure,
			value: formatSummaryDateTime(ride.departure),
			icon: IconTimetable,
		},
	];
};
